import { render, staticRenderFns } from "./adminOrganizationTree.vue?vue&type=template&id=3b721989&scoped=true&"
import script from "./adminOrganizationTree.vue?vue&type=script&lang=ts&"
export * from "./adminOrganizationTree.vue?vue&type=script&lang=ts&"
import style0 from "./adminOrganizationTree.vue?vue&type=style&index=0&id=3b721989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b721989",
  null
  
)

export default component.exports